import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
// BE AI-gen job statuses:
const NEW = 'NEW';
const PENDING = 'PENDING';
const PROCESSING = 'PROCESSING';
const SUCCEEDED = 'SUCCEEDED';
const FAILED_RETRY = 'FAILED_RETRY';
const FAILED_FOREVER = 'FAILED_FOREVER';
const FAILED_DO_NOT_RETRY = 'FAILED_DO_NOT_RETRY';
export const AiAbTestRequestStatuses = {
  NEW,
  PENDING,
  PROCESSING,
  SUCCEEDED,
  FAILED_RETRY,
  FAILED_FOREVER,
  FAILED_DO_NOT_RETRY
};
// Loading constants:
export const PROGRESS_TOTAL = 100;
export const PROGRESS_INCREMENT = PROGRESS_TOTAL / 2;
export const DELAY_BETWEEN_PROGRESS_INCREMENTS = 10000; // 10 seconds
export const MAX_LOAD_TIMEOUT = 180000; // 3 minutes

export const AI_SETTINGS_URL = `${getFullUrl('app')}/ai-settings/${PortalIdParser.get()}`;

// BE error types for FAILED statuses:
const AI_AB_TEST_FAILED_TO_GENERATE_SUGGESTIONS = 'AI_AB_TEST_FAILED_TO_GENERATE_SUGGESTIONS';
// Tokens: portalId, aiAbTestGeneratedSuggestionsId, commandExecutionId
// Cause: OpenAI / CA failures
const AI_AB_TEST_INVALID_GENERATED_SUGGESTIONS = 'AI_AB_TEST_INVALID_GENERATED_SUGGESTIONS';
// Tokens: portalId, aiAbTestGeneratedSuggestionsId, commandExecutionId
// Cause: GPT returns invalid response
const AI_AB_TEST_GENERATED_SUGGESTIONS_FLAGGED_CATEGORIES = 'AI_AB_TEST_GENERATED_SUGGESTIONS_FLAGGED_CATEGORIES';
// Tokens: portalId, aiAbTestGeneratedSuggestionsId, commandExecutionId, flaggedCategories
// Cause: Source HTML or generated suggestions contains flagged content
const AI_AB_TEST_EMPTY_LAYOUT_SECTIONS = 'AI_AB_TEST_EMPTY_LAYOUT_SECTIONS';
// Tokens: portalId, aiAbTestPageBuildId
// Cause: Page has empty layout sections (default template)
const AI_AB_TEST_FAILED_TO_UPDATE_GENERATION_STATUS = 'AI_AB_TEST_FAILED_TO_UPDATE_GENERATION_STATUS';
// Tokens: portalId, aiAbTestGeneratedSuggestionsId, commandExecutionId
// Cause: Failed to update AI A/B Test generation status
const AI_AB_TEST_FAILED_TO_UPDATE_SUGGESTIONS = 'AI_AB_TEST_FAILED_TO_UPDATE_SUGGESTIONS';
// Tokens: portalId, aiAbTestGeneratedSuggestionsId, commandExecutionId
// Cause: Failed to store generated suggestions in DB

export const AiAbTestFailureErrorTypes = {
  AI_AB_TEST_FAILED_TO_GENERATE_SUGGESTIONS,
  AI_AB_TEST_INVALID_GENERATED_SUGGESTIONS,
  AI_AB_TEST_GENERATED_SUGGESTIONS_FLAGGED_CATEGORIES,
  AI_AB_TEST_EMPTY_LAYOUT_SECTIONS,
  AI_AB_TEST_FAILED_TO_UPDATE_GENERATION_STATUS,
  AI_AB_TEST_FAILED_TO_UPDATE_SUGGESTIONS
};
// FlowErrorTypes
const MANUAL_TIMEOUT = 'MANUAL_TIMEOUT';
const NETWORK_ERROR = 'NETWORK_ERROR';
const UNKNOWN = 'UNKNOWN';
export const AiAbTestFlowErrorTypes = {
  MANUAL_TIMEOUT,
  NETWORK_ERROR,
  UNKNOWN
};